import values from 'mout/object/values'
import keys from 'mout/object/keys'
import sortByPropText from "../content/manageSets/sortByPropText"

/**
 * Determines if the student can resume at least one subtest, 
 * and what subtest to default resume.
 * @param {object} data {assessmentSubtests, destructuredSubtests, activity,} info from userAssessment
 * @returns {object} {firstIncompleteSubtest, topResume,}  
 */
export default function getResumeData({assessmentSubtests, destructuredSubtests, activity}) {
  let output = {}
  const sortedSubtests = sortByPropText(values(assessmentSubtests), 'index')
  sortedSubtests.forEach((subtest) => {
    let complete = destructuredSubtests[subtest.setId].complete === true
//    let resume = false
//    destructuredSubtests[subtest.setId].timeRemaining ? resume = true : null
    if (!output.firstIncompleteSubtest && !complete) {
      output.firstIncompleteSubtest = Object.assign({}, subtest)
      output.topResume = activity && keys(activity).length > 0
    }
  })
  if (output.firstIncompleteSubtest) {
    return output
  } else {
    return null
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getResumeData.js